export const ACTION_ICON_CELL = 'Actions';

export type CustomColumnConfig = {
  key: string;
  hide: boolean;
  index?: number;
};
